import { useRef, useState } from "react";

const DRAFT_LIFETIME_MS = 12 * 60 * 60 * 1000;

const emptyFields = {
  maritalStatus: "",
  community: "",
};

const readDraft = (storageKey) => {
  try {
    const storedDraft = window.sessionStorage.getItem(storageKey);
    if (!storedDraft) return emptyFields;

    const draft = JSON.parse(storedDraft);
    if (
      !draft?.updatedAt ||
      Date.now() - draft.updatedAt > DRAFT_LIFETIME_MS
    ) {
      window.sessionStorage.removeItem(storageKey);
      return emptyFields;
    }

    return {
      maritalStatus: draft.maritalStatus ?? "",
      community: draft.community ?? "",
    };
  } catch (error) {
    console.error("Unable to restore registration selections:", error);
    return emptyFields;
  }
};

export const useRegistrationRequiredFields = (storageKey) => {
  const [fields, setFields] = useState(() => readDraft(storageKey));
  const fieldsRef = useRef(fields);

  const updateField = (field, value) => {
    const nextFields = { ...fieldsRef.current, [field]: value };
    fieldsRef.current = nextFields;
    setFields(nextFields);

    try {
      window.sessionStorage.setItem(
        storageKey,
        JSON.stringify({ ...nextFields, updatedAt: Date.now() }),
      );
    } catch (error) {
      console.error("Unable to save registration selections:", error);
    }
  };

  const clearDraft = () => {
    try {
      window.sessionStorage.removeItem(storageKey);
    } catch (error) {
      console.error("Unable to clear registration selections:", error);
    }
  };

  return {
    selectedMaritalStatus: fields.maritalStatus,
    setSelectedMaritalStatus: (value) => updateField("maritalStatus", value),
    selectedCommunities: fields.community,
    setSelectedCommunities: (value) => updateField("community", value),
    clearDraft,
  };
};
